import { ChevronIcon } from "../../../../materials/icons/chevron-icon/ChevronIcon";
import { IconButton } from "../../../icon-button/IconButton.Parts";
import { Selection } from "../../../selection/Selection";
import {
  Content,
  LabelContainer,
  Placeholder,
  ToggleButtonContainer,
  getSelectionSize,
} from "../Trigger.Parts";
import { Props, SelectionContainer } from "./MultiSelectContent.Parts";

/**
 * Renders the content inside a multi select trigger, including the
 * label, placeholder, selected values, search input, and action buttons.
 */
export const MultiSelectContent = ({
  rows,
  small,
  hasContent,
  label,
  searchInputId,
  placeholder,
  buttonRef,
  visibleSelections,
  getLabelForValue,
  search,
  overflowCount,
  setSelection,
  selection,
  inputRef,
  disabled,
  context,
  referenceId,
  filteredOptions,
  activeIndex,
  searchInput,
  name,
}: Props) => (
  <>
    <Content
      $rows={rows}
      $multi
      $active={hasContent || (context.open && search)}
    >
      {label && (
        <LabelContainer
          $smallLabel={
            hasContent || selection.length > 0 || (context.open && search)
          }
        >
          <label htmlFor={search ? searchInputId : referenceId}>{label}</label>
        </LabelContainer>
      )}
      {placeholder && !selection.length && !search && (
        <Placeholder>{placeholder}</Placeholder>
      )}
      <SelectionContainer
        ref={buttonRef}
        $active={hasContent}
        $rows={rows}
        $small={small}
      >
        {visibleSelections.map((value) => (
          <Selection
            key={String(value)}
            $size={getSelectionSize(rows, small)}
            value={getLabelForValue(value)}
            onClick={(e) => {
              e.stopPropagation();
              if (search && context.open) inputRef.current?.focus();
              setSelection(selection.filter((v) => v !== value));
            }}
            active={
              context.dataRef.current.isFocusVisible &&
              activeIndex !== null &&
              value === filteredOptions[activeIndex]?.value
            }
            disabled={disabled}
          />
        ))}
        {overflowCount > 0 && (
          <Selection
            value={`+${overflowCount}`}
            $size={getSelectionSize(rows, small)}
            onClick={(e) => {
              e.stopPropagation();
              if (search && context.open) inputRef.current?.focus();
              setSelection(visibleSelections);
            }}
            disabled={disabled}
          />
        )}
        {search && searchInput}
      </SelectionContainer>
    </Content>
    <ToggleButtonContainer $rows={rows > 1}>
      <IconButton
        tabIndex={-1}
        type="button"
        onClick={() => context.onOpenChange(!context.open)}
        $small
        disabled={disabled}
      >
        <ChevronIcon orientation={context.open ? "up" : "down"} />
      </IconButton>
    </ToggleButtonContainer>
    {selection.map((value, i) => (
      <input type="hidden" name={name} value={String(value)} key={i} />
    ))}
  </>
);
